module.exports = __webpack_public_path__ + "fonts/pt_root-ui_medium.8ceb490.woff2";